module.exports = __webpack_public_path__ + "img/Vindome_dark.9019ae5.svg";